import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Translator from 'translator';
import { withStyles, CircularProgress, Fab, Tooltip } from '@material-ui/core';
import { NoteAdd as SendIcon } from '@material-ui/icons';

class FormAddFileButton extends PureComponent {
    static propTypes = {
        secondPosition: PropTypes.bool,
        classes: PropTypes.object.isRequired,
        sendFunc: PropTypes.func.isRequired,
        sendLoading: PropTypes.bool,
    };

    static defaultProps = {
        secondPosition: false,
        sendLoading: false,
    };

    render() {
        const { sendFunc, sendLoading, secondPosition, classes } = this.props;
        const positionClass = secondPosition ? classes.secondPosition : classes.firstPosition;

        if (sendLoading)
            return (
                <div className={positionClass}>
                    <CircularProgress size={25} />
                </div>
            );
        return (
            <div className={positionClass}>
                <Tooltip title={Translator.translate('generic.files.table.action.upload.tooltip')} placement="top">
                    <Fab
                        aria-label={Translator.translate('general.save')}
                        className={`${classes.btnSend} ${classes.fabSave}`}
                        size="small"
                        onClick={sendFunc}
                    >
                        <SendIcon className={classes.icon} />
                    </Fab>
                </Tooltip>
            </div>
        );
    }
}

const styles = theme => ({
    firstPosition: {
        position: 'absolute',
        top: 50,
        right: 100,
        [theme.breakpoints.down('md')]: {
            top: 30,
            right: 80,
        },
        [theme.breakpoints.down('sm')]: {
            top: 20,
            right: 70,
        },
        [theme.breakpoints.down('xs')]: {
            top: 18,
            right: 60,
        },
    },
    secondPosition: {
        position: 'absolute',
        top: 50,
        right: 146,
        [theme.breakpoints.down('md')]: {
            top: 30,
            right: 126,
        },
        [theme.breakpoints.down('sm')]: {
            top: 20,
            right: 116,
        },
        [theme.breakpoints.down('xs')]: {
            top: 18,
            right: 106,
        },
    },
    fabSave: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.common.white,
    },
    btnSend: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.common.white,
        marginLeft: 10,
        minHeight: 30,
        minWidth: 30,
        [theme.breakpoints.down('xs')]: {
            height: 30,
            width: 30,
        },
    },
    icon: {
        [theme.breakpoints.down('xs')]: {
            fontSize: '1.2rem',
        },
    },
});

export default withStyles(styles, { withTheme: true })(FormAddFileButton);



// WEBPACK FOOTER //
// ./data/components/FormAddFileButton.js